import { Field, Input, InputProps } from '@fluentui/react-components';
import { FieldValues, UseControllerProps } from 'react-hook-form';
import { NumberFormatValues, PatternFormat } from 'react-number-format';
import InputWrapper from '../layout/InputWrapper';
import { useFormField } from './useFormField';

type SsnInputProps<T extends FieldValues> = UseControllerProps<T> &
    InputProps & {
        label?: string;
    };

const SsnInput = <T extends FieldValues>(props: SsnInputProps<T>) => {
    const { name, control, rules, defaultValue, label } = props;

    const { field, errorMessage, isRequired } = useFormField({
        name,
        control,
        rules: { ...rules, minLength: { value: 9, message: 'SSN must be 9 digits' } },
        defaultValue,
    });

    const handleValueChange = (input: NumberFormatValues) => {
        const plainValue = input.value;
        field.onChange(plainValue);
    };

    return (
        <InputWrapper>
            <Field validationMessage={errorMessage} label={label} required={isRequired}>
                <PatternFormat
                    format="###-##-####"
                    customInput={Input}
                    value={field.value}
                    onValueChange={handleValueChange}
                    onBlur={field.onBlur}
                    allowEmptyFormatting
                    mask="#"
                />
            </Field>
        </InputWrapper>
    );
};

export default SsnInput;
